import { AfterContentChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { GetLanguageService } from './service/get-language/get-language.service';
import { MatIconRegistryService } from './service/mat-icon-registry/mat-icon-registry.service';
import { Subscription } from 'rxjs';
import { SpinnerService } from './service/spinner/spinner.service';
import { ChangeDetectorRef } from '@angular/core';
import { AuthService } from './service/auth/auth.service';
import { Title } from '@angular/platform-browser';
import { GoogleAnalyticsService } from './service/google-analytics/google-analytics.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy, AfterContentChecked {
    title = 'pineapplelab-landingpage';
    showSpinner: boolean = false;
    subscription: Subscription;
    homeSection: boolean = false;
    constructor(
        private authService: AuthService,
        private titleService: Title,
        private translateService: GetLanguageService,
        private matIconRegistry: MatIconRegistryService,
        public spinnerService: SpinnerService,
        private cdref: ChangeDetectorRef,
        private ga: GoogleAnalyticsService
    ) {
    }

    ngAfterContentChecked(): void {
        this.subscription = this.spinnerService.visibility.subscribe((value) => {
            this.showSpinner = value;
            this.lockScroll();
        });
        this.cdref.detectChanges();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnInit(): void {
        const title = this.authService.getProjectIdFromHostname(window.location.hostname);
        const formattedTitle = title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
        this.setFavicon();
        this.translateService.getJsonData();
        this.matIconRegistry.initializeAppIcons();
        this.titleService.setTitle(formattedTitle);
    }

    lockScroll() {
        if (this.showSpinner) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'scroll';
        }
    }

    setFavicon(){
        let link: HTMLLinkElement | null = document.querySelector("link[rel='icon']");
        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
        }
        const favicon = `https://firebasestorage.googleapis.com/v0/b/pineapplecms.appspot.com/o/projects%2F${this.authService.projectId}%2FimageBanner%2Ffavicon.png%26alt%3Dmedia?alt=media`;
        link.href = favicon;
    }
}
